import GetIcon from "Components/Global/Icons";

import * as S from "./styles";

const prefix = ({ icon, text, size, action, disabled }) => {
  const getIcon = () => <GetIcon type="regular" size={size} {...icon} />;

  return (
    <S.Wrapper size={size} onClick={action} disabled={disabled}>
      {icon && getIcon()} {text && text}
    </S.Wrapper>
  );
};

export default prefix;
